<div class="trackingTimeTimer">
  <div class="child">
    <div class="ellipsis handle">
      <img src="assets/icons/icon-menu-ellipsis.svg" />
    </div>
    <div
      class="timer"
      [ngStyle]="{ color: timerService.isPaused ? '#959DAB' : 'black' }"
    >
      {{ timerService.formattedTime() }}
    </div>
    <i
      class="feather info infoIcon"
      [attr.data-hover-content]="companyAndJob"
      style="margin-right: 30px"
    >
    </i>
  </div>
  <!-- <div class="child">
    {{ user.name }}
    {{ job.name }}
  </div> -->
  <div class="child">
    <div
      id="resume"
      [ngClass]="{ 'component-loading': isLoading }"
      class="timerIcon"
      style="background-color: #0075ff; color: white"
      *ngIf="timerService.isPaused"
      (click)="timerResume()"
    >
      <i class="tio-play"></i>
    </div>
    <div
      id="pause"
      class="timerIcon"
      style="background-color: #0075ff; color: white"
      *ngIf="!timerService.isPaused"
      [ngClass]="{ 'component-loading': isLoading }"
      (click)="timerPause()"
    >
      <i class="tio-pause"> </i>
    </div>
    <div
      id="stop"
      class="timerIcon"
      style="background-color: #fa3628; color: white"
      (click)="openStopConfirmationModal(job.name)"
    >
      <i class="tio-stop"> </i>
    </div>
    <div
      class="timerIcon"
      (click)="openJobPanel()"
      id="job-panel"
      style="background-color: #d7dbe1"
    >
      <i class="feather external-link"></i>
    </div>
  </div>
</div>
